<template>
	<div class="font-specimen-element">
		<div class="font-specimen-element-details">
			<p class="font-specimen-name small" :style="`color:${titleColour}`">{{ name }}</p>
			<input type="range" class="styled-slider slider-progress" :id="`font-variable-slider-${id}`" :min="min" :max="max" :step="step" v-model="weight" :value="defaultValue" />
		</div>
		<div class="font-specimen-element-text">
			<p :class="`canal-${weight}`" :style="`font-weight:${weight}; color:${fontColour}`" :id="`sample-text-${id}`">{{ sampleText }}</p>
		</div>
	</div>
</template>

<script>
import { ref, watch, onMounted } from "vue";

export default {
	props: {
		sampleText: {
			type: String,
			default: "",
		},
		weight: {
			type: [String, Number],
			default: "",
		},
		id: {
			type: Number,
			required: true,
		},
		min: {
			type: Number,
			required: true,
		},
		max: {
			type: Number,
			required: true,
		},
		step: {
			type: Number,
			required: true,
		},
		name: {
			type: String,
			default: "",
		},
		defaultValue: {
			type: Number,
		},
		titleColour: String,
		fontColour: String,
	},
	setup(props) {
		// const weight = ref(props.weight);
		const fontFamily = ref(null);
		const defaultValue = ref(props.defaultValue);
		const weight = ref(props.defaultValue ?? props.min);

		// Watch for changes in weight and update the style
		watch(weight, (newWeight) => {
			if (fontFamily.value) {
				fontFamily.value.style.fontWeight = newWeight;
				defaultValue.value = newWeight;
			}
		});

		// Lifecycle hook for mounted behavior
		onMounted(() => {
			// fontFamily.value = document.getElementById(`sample-text-${props.id}`);
			// const slider = document.getElementById(`font-variable-slider-${props.id}`);
			// slider.value = defaultValue.value;
			var sliders = document.querySelectorAll('.slider-progress')
			// console.log('sliders', sliders);
			// console.log('fam values', fontFamily.value);

			for (let e of sliders) {
				// console.log(e);
				e.style.setProperty("--value", e.value);
				e.style.setProperty("--min", e.min == "" ? "0" : e.min);
				e.style.setProperty("--max", e.max == "" ? "100" : e.max);
				e.addEventListener("input", () => e.style.setProperty("--value", e.value));
			}
		});

		return {
			weight,
			fontFamily,
			defaultValue,
		};
	},
};
</script>
